// @flow

export default (props) => {
  switch (props.decorator || props.is) {
    case 'WebLayout':
      return import('./components/WebLayout');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    // case 'GtmHandler':
    //   return import('./components/WebGtmHandler');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    // case 'Typeahead':
    //   return import('fg-frontend/components/Typeahead');
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'Hamburger':
      return import('./components/Hamburger');
    case 'Menu':
      return import('./components/Menu');
    case 'Modal':
      return import('./components/Modal');
    case 'PhotoSwipeWithSlick':
      return import('./components/PhotoSwipeWithSlick');
    case 'SlickSlider':
      return import('./components/SlickSlider');
    case 'DataLayerHandler':
      return import('./components/DataLayerHandler');
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-chtitvic/src/js/configureWebComponents.js